<template>
  <div class="tsbg-container">
    <div class="top-filter" v-if="userinfo.tenantType === 0 || userinfo.tenantType === 1">
        <el-form :model="queryInfo" size="medium"  :inline="true">
            <el-form-item :label="$t('finance.name18')" prop="tenantId">
              <el-cascader ref="refHandle1" v-model="tenantIds" :placeholder="$t('public.name1')" :show-all-levels="false"  @change="handleChange1" :props="{ lazy: true, lazyLoad: loadOptions1,  checkStrictly: true }" clearable></el-cascader>
            </el-form-item>
            <el-form-item :label="$t('bike.name98')" prop="ebikeCode">
              <el-input v-model="queryInfo.ebikeCode" :placeholder="$t('public.name5')" clearable> </el-input>
            </el-form-item>
            <el-form-item :label="$t('bike.name145')" prop="searchTime">
              <el-date-picker
            v-model="queryInfo.searchTime"
            type="daterange"
           value-format="yyyy-MM-dd"
            :range-separator="$t('public.name9')"
            :start-placeholder="$t('public.name10')"
            :end-placeholder="$t('public.name11')"
          >
          </el-date-picker>
            </el-form-item>
            <el-form-item label="" prop="searchTime">
              <div>
        <el-button type="primary" size="medium" @click="getPageList">{{ $t('public.name3') }}</el-button>
        <el-button size="medium" @click="restQuery">{{ $t('public.name4') }}</el-button>
      </div>
    </el-form-item>
        </el-form>
    </div>
    <div class="top-filter" v-else>
        <el-form :model="queryInfo" size="medium" :inline="true">
            <!-- <el-form-item :label="$t('finance.name18')" prop="tenantId">
              <el-select v-model="queryInfo.tenantId" :placeholder="$t('public.name1')">
                <el-option v-for="item in tenantOptions" :key="item.tenantId" :label="item.tenantName" :value="item.tenantId"> </el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item :label="$t('bike.name2')" prop="ebikeCode">
              <el-select v-model="queryInfo.ebikeCode" :placeholder="$t('public.name1')">
                <el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <div>
        <el-button type="primary" size="medium" @click="getPageList">{{ $t('public.name3') }}</el-button>
        <el-button size="medium" @click="restQuery">{{ $t('public.name4') }}</el-button>
      </div>
            </el-form-item>
        </el-form>
    </div>
    <div class="add-car">
      <el-button type="primary" icon="el-icon-plus" size="medium" @click="showAddBikeDialog" v-if="buttonPerms.indexOf('history/addBike') > -1">{{ $t('bike.name3') }}</el-button>
      <el-button type="primary" icon="el-icon-plus" size="medium" @click="showAddReport" v-if="buttonPerms.indexOf('ebikeDebugReport/add') > -1">{{ $t('bike.name146') }}</el-button>
    </div>
    <el-table v-if="userinfo.tenantType === 0 || userinfo.tenantType === 1"  :data="tableList" :header-cell-style="{ fontSize: '14px', backgroundColor: '#f5f5f5', color: '#555' }" v-loading="tableLoading">
      <el-table-column :label="$t('bike.name41')" prop="ebikeId" sortable></el-table-column>
      <el-table-column :label="$t('finance.name7')" prop="tenantName" sortable></el-table-column>
      <el-table-column :label="$t('bike.name147')" prop="startTime" sortable>
        <template slot-scope="scope">{{ scope.row.startTime | tzDisplay }}</template>
      </el-table-column>
      <el-table-column :label="$t('bike.name148')" prop="endTime" sortable>
        <template slot-scope="scope">{{ scope.row.endTime | tzDisplay }}</template>
      </el-table-column>
      <el-table-column :label="$t('bike.name11')" width="120px" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" @click="getEbikeDebugReportDetail(scope.row)">{{ $t('bike.name12') }}</el-button>
          <el-button type="text" @click="delList(scope.row)" style="color:#ea4646">{{ $t('bike.name13') }}</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-table   v-else  :data="tableList" :header-cell-style="{ fontSize: '14px', backgroundColor: '#f5f5f5', color: '#555' }" v-loading="tableLoading">
      <el-table-column :label="$t('bike.name38')" prop="ebikeId" sortable></el-table-column>
      <!-- <el-table-column :label="$t('finance.name7')" prop="tenantName" sortable></el-table-column> -->
      <el-table-column :label="$t('bike.name6')" prop="createTime" sortable>
        <template slot-scope="scope">{{ scope.row.createTime | tzDisplay }}</template>
      </el-table-column>
      <!-- <el-table-column :label="$t('bike.name7')" prop="speed" sortable></el-table-column> -->
      <!-- <el-table-column label="经纬度" prop="duration" sortable></el-table-column> -->
      <!-- <el-table-column :label="$t('bike.name8')" prop="duration" sortable></el-table-column> -->
      <!-- <el-table-column :label="$t('bike.name9')" prop="duration" sortable></el-table-column> -->
      <!-- <el-table-column :label="$t('bike.name10')" prop="duration" sortable></el-table-column> -->
      <el-table-column :label="$t('bike.name11')" width="120px" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" @click="getEbikeDebugReportDetail(scope.row)">{{ $t('bike.name12') }}</el-button>
          <el-button type="text" @click="delList(scope.row)" style="color:#ea4646">{{ $t('bike.name13') }}</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--分页-->
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryInfo.page"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="queryInfo.limit"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>

    <!--添加报告-->
    <AppDialog size="sm" :title="$t('bike.name146')" :visible.sync="reportDialog" v-if="reportDialog" :before-close="close" >
      <el-form ref="reportFormRef" :label-width="formLabelWidth('lg2')" :rules="reportFormRules" :model="reportInfo" class="width100">
        <el-form-item :label="$t('bike.name150')" prop="tenantId" >
          <el-select v-model="reportInfo.tenantId" :placeholder="$t('public.name1')" class="width100" @change="changeTenant">
            <el-option v-for="item in tenantOptions" :key="item.tenantId" :label="item.tenantName" :value="item.tenantId"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('bike.name65')" prop="ebikeId" >
          <el-select v-model="reportInfo.ebikeId" :placeholder="$t('public.name1')" class="width100">
            <el-option v-for="item in ebikeIdOptions" :key="item" :label="item" :value="item"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('bike.name145')" prop="startTime" >
          <el-date-picker v-model="reportInfo.startTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" :placeholder="$t('public.name6')" class="width100"> </el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('bike.name151')" prop="endTime" >
          <el-date-picker v-model="reportInfo.endTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" :placeholder="$t('public.name6')" class="width100"> </el-date-picker>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button type="primary" @click="submitReport" :loading="loading">{{ $t('public.name13') }}</el-button>
        <el-button @click="close">{{ $t('public.name14') }}</el-button>
      </template>
    </AppDialog>

      <!--溧电详情提示-->
      <el-dialog
        ref="reportDetailsDialog"
        :visible.sync="dialogCycleTraceVisible"
        v-if="dialogCycleTraceVisible"
        :fullscreen="true"
        append-to-body
        :close-on-click-modal="false"
        :before-close="handleCycleTraceClose"
        :title="$t('bike.name82')"
        custom-class="report-details-dialog"
        @opened="handleReportDetailsOpened"
      >
       <VisualReportComPonents
         ref="visualReportRef"
         :key="itemData.ebikeDebugReportId"
         :itemdata="itemData"
       />
        <!-- <el-table :data="detailList" :header-cell-style="{ fontSize: '14px', backgroundColor: '#f5f5f5', color: '#555' }" v-loading="tableLoading1"  >
          <el-table-column label="时间" prop="dataTime" sortable  width="150">
            <template slot-scope="scope">
              <div>{{ $moment(scope.row.dataTime).format('YYYY-MM-DD HH:mm:ss') }}</div>
            </template>
          </el-table-column>
          <el-table-column label="速度" prop="speed" sortable width="100"></el-table-column>
          <el-table-column label="经纬度" prop="lng" sortable width="150">
            <template slot-scope="scope">
              <div>{{ scope.row.lng }},{{ scope.row.lat }}</div>
            </template>
          </el-table-column>
          <el-table-column label="高度" prop="alt" sortable width="100"></el-table-column>
          <el-table-column label="控制器电压" prop="batteryVoltage" sortable width="120"></el-table-column>
          <el-table-column label="控制器电流" prop="batteryCurrent" sortable width="120"></el-table-column>
          <el-table-column label="控制器温度" prop="controllerTemp" sortable width="120"></el-table-column>
          <el-table-column label="电池容量" prop="batteryCapacity" sortable width="120"></el-table-column>
          <el-table-column label="电池相对容量" prop="batteryRelaCapacity" sortable width="150"></el-table-column>
          <el-table-column label="电池温度" prop="batteryTemp" sortable width="120"></el-table-column>
          <el-table-column label="转把电压" prop="turnVoltage" sortable width="120"></el-table-column>
          <el-table-column label="电机温度" prop="motorTemp" sortable width="120"></el-table-column>
          <el-table-column label="电机功率" prop="powerPercent" sortable width="120"></el-table-column>
          <el-table-column label="踏板" prop="cadence" sortable width="100"></el-table-column>
          <el-table-column label="蓝牙连接情况" prop="bluetoothConnection" sortable width="150">
            <template slot-scope="scope">
              <div>{{ ['未连接','已连接'][scope.row.bluetoothConnection] }}</div>
            </template>
          </el-table-column>
          <el-table-column label="GPS连接情况" prop="gpsConnection" sortable width="150">
            <template slot-scope="scope">
              <div>{{ ['未定位','正常'][scope.row.gpsConnection] }}</div>
            </template>
          </el-table-column>
          <el-table-column label="仪表连接情况" prop="meterConnection" sortable width="150">
            <template slot-scope="scope">
              <div>{{ ['未连接','已连接'][scope.row.meterConnection] }}</div>
            </template>
          </el-table-column>
    </el-table>
    <el-pagination
      background
      @size-change="handleDetailsSizeChange"
      @current-change="handleDetailsCurrentChange"
      :current-page="page"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="limit"
      layout="total, sizes, prev, pager, next, jumper"
      :total="detailsTotal"
    >
    </el-pagination> -->
    </el-dialog>
<!--添加车辆-->
<AppDialog size="sm" :title="$t('bike.name3')" :visible.sync="addBikeDialog" v-if="addBikeDialog" :before-close="closeAddBikeDialog" >
        <el-form :label-width="formLabelWidth('xl')" style="width:100%;" :model="addEBikeInfo" :rules="addBikeFormRules" ref="addBikeRef">
          <el-form-item :label="$t('bike.name160')"  prop="tenantIds">
            <el-cascader ref="refHandle" style="width:80%" v-model="addEBikeInfo.tenantIds" :placeholder="$t('public.name1')" @change="handleChange" :props="{ lazy: true, checkStrictly: true, lazyLoad: loadOptions }" clearable></el-cascader>
        </el-form-item>
        <el-form-item :label="$t('bike.name65')" prop="ebikeId">
            <el-input
            style="width:80%"
            :placeholder="$t('public.name5')"
            v-model="addEBikeInfo.ebikeId">
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('bike.name446')" prop="mac">
            <el-input
             style="width:80%"
             :placeholder="$t('public.name5')"
            v-model="addEBikeInfo.mac">
          </el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button type="primary" @click="handlerAddBike" :loading="loading3">{{ $t('public.name13') }}</el-button>
        <el-button @click="closeAddBikeDialog">{{ $t('public.name14') }}</el-button>
      </template>
    </AppDialog>
  </div>
</template>
<script>
import { tenantList } from '@/api/manage.js'
import { ebikeDebugReportList, ebikeDebugReportdDelete, ebikeDebugReportAdd, ebikeDebugReportExport, listEbikeIdByTenantId, addEbike } from '@/api/bike.js'
import { mapGetters } from 'vuex'
import { downloadExcel } from '@/utils/utils'
import VisualReportComPonents from './visualReportComPonents.vue'
import AppDialog from '@/components/AppDialog/index.vue'
import { scheduleDialogScrollReset } from '@/utils/dialogScroll'
import { clearFormValidateOnLangChange } from '@/utils/i18nFormHelpers.js'
export default {
  computed: {
    ...mapGetters(['userinfo']),
    reportFormRules () {
      return {
        tenantId: [
          {
            required: true,
            message: this.$t('bike.name476'),
            trigger: 'blur'
          }
        ],
        ebikeId: [
          {
            required: true,
            message: this.$t('bike.name473'),
            trigger: 'blur'
          }
        ],
        startTime: [
          {
            required: true,
            message: this.$t('bike.name477'),
            trigger: 'blur'
          }
        ],
        endTime: [
          {
            required: true,
            message: this.$t('bike.name478'),
            trigger: 'blur'
          }
        ]
      }
    },
    addBikeFormRules () {
      return {
        tenantIds: [
          {
            required: true,
            message: this.$t('public.name45'),
            trigger: 'blur'
          }
        ],
        ebikeId: [
          {
            required: true,
            message: this.$t('bike.name473'),
            trigger: 'blur'
          }
        ],
        mac: [
          {
            required: true,
            message: this.$t('bike.name479'),
            trigger: 'blur'
          }
        ]
      }
    }
  },
  data() {
    return {
      tenantIds: [],
      page: 1,
      limit: 10,
      detailsTotal: 0,
      queryInfo: {
        page: 1,
        limit: 10,
        ebikeCode: '',
        tenantId: '',
        searchTime: null
      },
      tableList: [],
      tenantOptions: [],
      ebikeIdOptions: [],
      options2: [],
      dialogCycleTraceVisible: false,
      total: 0,
      detailList: [],
      itemData: {},
      loading: false,
      tableLoading: false,
      tableLoading1: false,
      reportDialog: false,
      reportInfo: {
        tenantId: '',
        ebikeId: '',
        startTime: '',
        endTime: ''
      },
      buttonPerms: '',
      loading3: false,
      addBikeDialog: false,
      addEBikeInfo: {
        tenantIds: '',
        tenantId: '',
        ebikeId: '',
        mac: '',
        testStatus: true
      }
    }
  },
  components: {
    VisualReportComPonents,
    AppDialog
  },
  created() {
    this.buttonPerms = localStorage.getItem('buttonPerms')
  },
  mounted() {
    this.getTenantList()
    this.queryList()
    this.$bus.$on('lang', this.handleLangChange)
  },
  beforeDestroy() {
    this.$bus.$off('lang', this.handleLangChange)
  },
  methods: {
    handleLangChange () {
      clearFormValidateOnLangChange(this, ['reportFormRef', 'addBikeRef'])
    },
    getTenantList() {
      const data = {
        page: 1,
        limit: 500,
        tenantType: 1
      }
      tenantList(data)
        .then(res => {
          this.tenantOptions = res.data.list
        })
        .catch(() => {
          this.tenantOptions = []
        })
    },
    changeTenant(id) {
      listEbikeIdByTenantId({ tenantId: id })
        .then((res) => {
          this.ebikeIdOptions = res.data
        })
        .catch(() => {
          this.ebikeIdOptions = []
        })
    },
    getPageList() {
      this.queryInfo.page = 1
      this.queryInfo.limit = 10
      this.queryList()
    },
    buildDebugReportListParams(page, limit) {
      const params = { page, limit }
      if (this.queryInfo.ebikeCode) {
        params.ebikeCode = this.queryInfo.ebikeCode.trim()
      }
      if (this.queryInfo.tenantId) {
        params.tenantId = this.queryInfo.tenantId
      }
      if (this.queryInfo.searchTime !== null) {
        const { startTime, endTime } = this.$tz.dateRangeToAccountQuery(this.queryInfo.searchTime)
        params.startTime = startTime
        params.endTime = endTime
      }
      return params
    },
    async queryList() {
      this.tableLoading = true
      try {
        const params = this.buildDebugReportListParams(this.queryInfo.page, this.queryInfo.limit)
        const res = await ebikeDebugReportList(params)
        if (res && res.code === 200) {
          this.tableList = (res.data && res.data.list) || []
          this.total = (res.data && res.data.total) || 0
        } else {
          this.tableList = []
          this.total = 0
        }
      } catch (e) {
        this.tableList = []
        this.total = 0
      } finally {
        this.tableLoading = false
      }
    },
    getEbikeDebugReportList() {
      return this.queryList()
    },
    restQuery() {
      this.queryInfo = {
        page: 1,
        limit: 10,
        ebikeCode: '',
        tenantId: '',
        searchTime: null
      }
      this.tenantIds = []
      this.queryList()
    },
    showAddReport() {
      this.reportDialog = true
    },
    submitReport() {
      this.$refs.reportFormRef.validate(valid => {
        if (valid) {
          this.loading = true
          const payload = {
            ...this.reportInfo,
            // 单选日期时间转账号时区
            startTime: this.$tz.browserLocalToAccountString(this.reportInfo.startTime),
            endTime: this.$tz.browserLocalToAccountString(this.reportInfo.endTime)
          }
          ebikeDebugReportAdd(payload).then(res => {
            this.loading = false
            this.close()
            this.queryList()
          }).catch(() => {
            this.loading = false
          })
        } else {
          return false
        }
      })
    },
    close() {
      this.reportInfo = {
        tenantId: '',
        ebikeId: '',
        startTime: '',
        endTime: ''
      }
      this.reportDialog = false
    },
    getEbikeDebugReportDetail(row) {
      this.dialogCycleTraceVisible = true
      // this.tableLoading1 = true
      this.itemData = row
      // console.log('====', this.itemData)
      // ebikeDebugReportDetail({ ebikeDebugReportId: row.ebikeDebugReportId, page: this.page, limit: this.limit })
      //   .then(res => {
      //     this.tableLoading1 = false
      //     if (res.code === 200) {
      //       this.detailList = res.data.list
      //       this.detailsTotal = res.data.total
      //     } else {
      //       this.detailList = []
      //     }
      //   })
      //   .catch(() => {
      //     this.tableLoading1 = false
      //   })
    },
    exportDetails() {
      this.loading = true
      ebikeDebugReportExport({ ebikeDebugReportId: this.itemData.ebikeDebugReportId }).then(res => {
        this.loading = false
        downloadExcel(res, this.itemData.ebikeId + this.$t('bike.name447'))
      }).catch(() => {
        this.loading = false
      })
    },
    goBikeList() {
      this.$bus.$emit('clickIndex', 'bikelist', 1)
      // this.$router.push('/bikelist')
    },
    delList(row) {
      this.$confirm(this.$t('public.name40'), this.$t('public.name23'), {
        confirmButtonText: this.$t('public.name25'),
        cancelButtonText: this.$t('public.name14'),
        type: 'warning'
      })
        .then(() => {
          ebikeDebugReportdDelete({ ebikeDebugReportId: row.ebikeDebugReportId })
            .then(res => {
              if (res.code === 200) {
                this.$message({
                  type: 'success',
                  message: this.$t('public.name30')
                })
                this.queryInfo.page = 1
                this.queryList()
              }
            })
            .catch(() => {})
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('public.name31')
          })
        })
    },
    handleCycleTraceClose() {
      this.dialogCycleTraceVisible = false
    },
    handleReportDetailsOpened () {
      this.$nextTick(() => {
        scheduleDialogScrollReset(this.$refs.reportDetailsDialog)
        const ref = this.$refs.visualReportRef
        if (ref) {
          if (typeof ref.scheduleChartsResize === 'function') {
            ref.scheduleChartsResize()
          }
          if (typeof ref.scheduleTdtMapRefresh === 'function') {
            ref.scheduleTdtMapRefresh()
          }
        }
      })
    },
    // 监听pagesizes的事件
    handleSizeChange(newSize) {
      this.queryInfo.limit = newSize
      this.queryInfo.page = 1
      this.queryList()
    },
    // 监听页码值改变事件
    handleCurrentChange(newPage) {
      this.queryInfo.page = newPage
      this.queryList()
    },
    // 监听pagesizes的事件
    handleDetailsSizeChange(newSize) {
      this.limit = newSize
      this.page = 1
    },
    handleDetailsCurrentChange(newPage) {
      this.page = newPage
    },
    loadOptions1(node, resolve) {
      if (node.level === 2) {
        resolve([])
        return
      }
      let data = {
        page: 1,
        limit: 500,
        tenantType: 1
      }
      if (node.level === 1) {
        data = {
          page: 1,
          limit: 500,
          tenantType: 2,
          parentId: node.value
        }
      }
      tenantList(data)
        .then(res => {
          if (res.data.list) {
            const options = res.data.list.map(item => ({
              value: item.tenantId,
              label: item.tenantName,
              leaf: node.level >= 1
            }))
            resolve(options)
          } else {
            resolve([])
          }
        })
        .catch(() => {})
    },
    handleChange1(value) {
      // 处理选项变化
      this.queryInfo.tenantId = value[value.length - 1]
      const panelRefs = this.$refs.refHandle1.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.activePath.forEach(item => {
          if (item.children.length === 0) {
            panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
          }
        })
      }
    },
    loadOptions(node, resolve) {
      if (node.level === 3) {
        resolve([])
        return
      }
      let data = {
        page: 1,
        limit: 500,
        tenantType: 1
      }
      if (node.level === 1) {
        data = {
          page: 1,
          limit: 500,
          tenantType: 2,
          parentId: node.value
        }
      }
      if (node.level === 2) {
        data = {
          page: 1,
          limit: 500,
          tenantType: 3,
          parentId: node.value
        }
      }
      tenantList(data)
        .then(res => {
          if (res.data.list) {
            const options = res.data.list.map(item => ({
              value: item.tenantId,
              label: item.tenantName,
              leaf: node.level >= 2
            }))
            resolve(options)
          } else {
            resolve([])
          }
        })
        .catch(() => {})
    },
    handleChange(value) {
      console.log('value===', value)
      // 处理选项变化
      this.addEBikeInfo.tenantId = value[value.length - 1]
      const panelRefs = this.$refs.refHandle.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.activePath.forEach(item => {
          if (item.children.length === 0) {
            panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
          }
        })
      }
    },
    showAddBikeDialog() {
      this.addBikeDialog = true
    },
    closeAddBikeDialog() {
      this.addBikeDialog = false
      this.addEBikeInfo = {
        tenantId: '',
        tenantIds: '',
        ebikeId: '',
        mac: '',
        testStatus: true
      }
    },
    handlerAddBike() {
      this.$refs.addBikeRef.validate(valid => {
        if (valid) {
          this.loading3 = true
          const addEBikeInfo = {
            tenantId: this.addEBikeInfo.tenantId,
            ebikeId: this.addEBikeInfo.ebikeId.trim(),
            mac: this.addEBikeInfo.mac.trim(),
            testStatus: true
          }
          addEbike(addEBikeInfo).then(res => {
            this.loading3 = false
            if (res.code === 200) {
              this.$message({ message: this.$t('public.name41'), type: 'success' })
              this.closeAddBikeDialog()
            }
          }).catch(() => {
            this.loading3 = false
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.tsbg-container {
  display: flex;
  flex-direction: column;
  // min-width: 800px;
  // padding-left: 30px;
  // padding-right: 30px;

  .top-filter {
    display: flex;
    justify-content: space-between;
  }
  .add-car {
   display: flex;
   flex-direction: row;
  }
  .margin-top30 {
    margin-top: 30px;
  }
  .width100{
    width: 100%;
  }
}
</style>
